import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";
import Swal from 'sweetalert2';
import moment from 'moment';

const COLABORADOR = 'COLABORADOR';
const LISTADO = 'LISTADO';
const TIPO = 'TIPO';
const PUESTO = 'PUESTO';
const LOADER = 'LOADER';
const LOADER_REP = 'LOADER_REP';
const MODULO = 'MODULO';
const LISTADO_PERIODOS = 'LISTADO_PERIODOS';
const PERIODO_D = 'PERIODO_D';
const DETALLE = 'DETALLE';
const DETALLE_PRODUCTOS = 'DETALLE_PRODUCTOS';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

const setLoaderRep = loaderRep => ({
    type: LOADER_REP,
    loaderRep,
});

export const listarColaborador = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id };
    api.get('/colaborador/empresa_colaborador_pais', params).then(data => {
        const lista = [];
        if (data) {
            data.forEach(item => {
                lista.push({
                    value: item.id,
                    label: item.codigo+' - ' + item.nombre
                })
            })
        }
        dispatch({type: COLABORADOR, emp: lista })
    }).catch((error) => {
        return [];
    })
}

export const datosColaborador = (emp) => (dispatch) => {
    api.get(`/colaborador/${emp}`).then((response) => {
        dispatch({type: PUESTO, cargo: response.cargo })
    }).catch((error) => {
        return [];
    })
}

export const registroVenta = (periodoD) => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormVentaEmpleado.values;
    let fechaI = moment(periodoD.fecha_inicio);
    let fechaF = moment(periodoD.fecha_fin);
    let fecha = moment(data.fecha);
    if (fecha >= fechaI && fecha <= fechaF) {

        let id_empresa = id_emp[5]
        
        if (data === undefined) {
            Swal.fire({
                title: 'Venta empleado',
                text: 'Debe de seleccionar colaborador',
                type: 'error',
            })
        } else {
            if (data.fecha === undefined || data.fecha === '') {
                Swal.fire({
                    title: 'Venta empleado',
                    text: 'Debe de ingresar fecha',
                    type: 'error',
                })
            } else {
                if (data.tipo === undefined || data.tipo === '') {
                    Swal.fire({
                        title: 'Falta',
                        text: 'Debe de seleccionar tipo',
                        type: 'error',
                    })
                } else {
                    const formData = {
                        colaborador: data.colaborador.value,
                        fecha: data.fecha,
                        tipo_pedido: data.tipo,
                        detalleVenta: data.detalle,
                        observacion: data.observaciones,
                        empresa: id_empresa
                    }
                    dispatch(setLoader(true));
                    api.post('/rrhh_venta_empleado/', formData).then(() => {
                        NotificationManager.success(
                            'Venta creada correctamente',
                            'Exito',
                            3000
                        );
                        let ruta = `/rr_hh/${id_emp[5]}/venta_empleado/${id_emp[7]}`
                        dispatch(push(ruta));
                    }).catch((error) => {
                    NotificationManager.error(
                        error.msj,
                        'Error',
                        0
                    );
                    }).finally(() => {
                        dispatch(setLoader(false));
                    });
                }
            }
        }
    }else{
        Swal.fire({
            title: 'Venta empleado',
            text: 'Fecha fuera del periodo',
            type: 'error',
        })
    }
}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en buscar modulo',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    
    let id = id_emp[5];
    let periodo = id_emp[7];
    let params = { id, periodo };
    dispatch(setLoader(true));
    api.get('/rrhh_venta_empleado/', params).then((response)=>{
        dispatch({type: LISTADO, data: response })
    }).catch(error=>{
        NotificationManager.error(
            'Ocurrió un error al listar faltas',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

const leerDetalleProductos = id => (dispatch) => {
    api.get(`/rrhh_venta_empleado_detalle/${id}`).then((response)=>{
        dispatch({ type: DETALLE_PRODUCTOS, detalleProducto: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error',
            'Error',
            0
        );
    })
};

export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/rrhh_venta_empleado/${id}`).then((response) => {
        dispatch({type: TIPO, tipo: response.tipo_pedido})
        dispatch(initializeForm('FormVentaEmpleado', response ));
        dispatch(leerDetalleProductos(response.id));
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al consultar venta empleado',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

const limpiarDatos = () => (dispatch) => {
    dispatch({ type: PUESTO, cargo: [] });
    dispatch({ type: DETALLE, detallePro: [] })
};

export const modificarVenta = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormVentaEmpleado.values;
    
    const id = datos.id;

    if (datos.fecha === undefined || datos.fecha_inicio === '') {
        Swal.fire({
            title: 'Venta empleado',
            text: 'Debe de ingresar fecha',
            type: 'error',
        })
    } else {
        let tipo_pedido = ''
        if (datos.tipo_mod) {
            tipo_pedido = datos.tipo_mod
        } else {
            tipo_pedido = datos.tipo_pedido
        }

        const formData = {
            id: id,
            fecha: datos.fecha,
            tipo_pedido: tipo_pedido,
            observacion: datos.observaciones,
        }
        dispatch(setLoader(true));
        api.put(`/rrhh_venta_empleado/${id}/`, formData).then(() => {
            NotificationManager.success(
                'Venta modificada correctamente',
                'Exito',
                3000
            );
            let ruta = `/rr_hh/${id_emp[5]}/venta_empleado/${id_emp[7]}`
            dispatch(push(ruta));
        }).catch((error) => {
            NotificationManager.error(
                error.msj,
                'Error',
                0
            );
        }).finally(() => {
            dispatch(setLoader(false));
        });
    }
}

export const listarPeriodos = (year) => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id, year };
    dispatch(setLoader(true));
    api.get('/periodos/periodo_empresa_year', params).then((response)=>{
        let periodo = [];
        response.forEach(item=>{
            periodo.push({
                value: item.id,
                label: item.periodo
            })
        })
        dispatch({ type: LISTADO_PERIODOS, periodos: periodo });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar los periodos',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const leerPeriodoD = (id, id_periodo) => (dispatch) => {
    const params = { id, id_periodo };
    api.get('/periodos/periodo', params).then((response) => {
        dispatch({ type: PERIODO_D, periodoD: response.periodo });
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al consultar periodo',
            'Error',
            2000
        );
    })
}

const actualizar = () => (dispatch, getStore) => {
    const data = getStore().form.FormVentaEmpleado.values;
    dispatch(initializeForm('FormVentaEmpleado', {
        ...data,
        producto: null
    }));
    dispatch({ type: DETALLE, detallePro: data.detalle })
};

export const agregarLinea = (periodoD) => (dispatch,getStore) => {
    const data = getStore().form.FormVentaEmpleado.values;
    let fechaI = moment(periodoD.fecha_inicio);
    let fechaF = moment(periodoD.fecha_fin);
    let fecha = moment(data.fecha);
    if (fecha >= fechaI && fecha <= fechaF) {

        if (data.cantidad === undefined || data.cantidad === 0) {
            Swal.fire({
                title: 'Venta empleado',
                text: 'Debe de ingresar cantidad',
                type: 'error',
            })
        } else {
            if (data.producto === undefined || data.producto === null) {
                Swal.fire({
                    title: 'Venta empleado',
                    text: 'Debe de seleccionar producto',
                    type: 'error',
                })
            } else {
                if (data.tipo === undefined || data.tipo === '' || data.tipo === null) {
                    Swal.fire({
                        title: 'Venta empleado',
                        text: 'Debe de seleccionar tipo',
                        type: 'error',
                    })
                } else {
                    if (data.fecha === undefined || data.fecha === null) {
                        Swal.fire({
                            title: 'Venta empleado',
                            text: 'Debe de ingresar fecha',
                            type: 'error',
                        })
                    } else {
                        const detalleActual = data.detalle || [];
                        const producto = data.producto.value.split('#')
                        if (detalleActual.length > 0) {
                            const dato = detalleActual.find(item => item.idPro === producto[0].trim());

                            if (dato) {
                                NotificationManager.error(
                                    'Producto ya fue ingresado',
                                    'Error',
                                    3000
                                );
                            } else {
                                const nuevoDetalle = [
                                    ...detalleActual,
                                    {
                                        id: Date.now(),
                                        idPro: producto[0].trim(),
                                        sku: producto[1].trim(),
                                        producto: producto[2].trim(),
                                        cantidad: data.cantidad,
                                        precio: parseFloat(producto[3]),
                                        total: parseFloat(parseFloat(data.cantidad)*parseFloat(producto[3])).toFixed(2)
                                    }
                                ];
                                data.cantidad = 0;
                                data.detalle = nuevoDetalle;
                                NotificationManager.success(
                                    'Producto ingresado correctamente',
                                    'Exito',
                                    3000
                                );
                                dispatch(actualizar());
                            }
                        }else{
                            const nuevoDetalle = [
                                ...detalleActual,
                                {
                                    id: Date.now(),
                                    idPro: producto[0].trim(),
                                    sku: producto[1].trim(),
                                    producto: producto[2].trim(),
                                    cantidad: data.cantidad,
                                    precio: parseFloat(producto[3]),
                                    total: parseFloat(parseFloat(data.cantidad)*parseFloat(producto[3])).toFixed(2)
                                }
                            ];
                            data.cantidad = 0;
                            data.detalle = nuevoDetalle;
                            NotificationManager.success(
                                'Producto ingresado correctamente',
                                'Exito',
                                3000
                            );
                            dispatch(actualizar());
                        }
                    }
                }
            }
        }
    }else{
        Swal.fire({
            title: 'Venta empleado',
            text: 'Fecha fuera del periodo',
            type: 'error',
        })
    }
}

export const listarProductos = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const params = {id, search}
    return api.get('/rrhh_listado_precios/productos',params).then(data=>{
        const productos = [];
        if(data){
            data.forEach(item=>{
                productos.push({
                    value: item.id + '#' + item.sku + '#' + item.producto + '#' + item.precio,
                    label: item.sku + ' / ' + item.producto
                })
            })
        }
        return productos;
    }).catch((error)=>{
        
        return [];
    })
}

const eliminarLinea = (id) => (dispatch, getStore) => {
    const data = getStore().form.FormVentaEmpleado.values;
    const nuevoDetalle = data.detalle.filter(element => element.id !== id);
    dispatch({ type: DETALLE, detallePro: nuevoDetalle })
    dispatch(initializeForm('FormVentaEmpleado', {
        ...data,
        detalle: nuevoDetalle,
    }));
};

const eliminarLineaProducto = id => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`/rrhh_venta_empleado_detalle/${id}`).then((response) => {
        dispatch(leerDetalleProductos(response.id));
    }).catch(() => {
        NotificationManager.error(
            'Ocurrió un error en eliminar',
            'Error',
            0
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const agregarLineaProducto = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    
    const data = getStore().form.FormVentaEmpleado.values;
    if (data.producto === undefined || data.producto === null) {
        Swal.fire({
            title: 'Venta empleado',
            text: 'Debe de seleccionar producto',
            type: 'error',
        })
    } else {
        if (data.cantidad === undefined || data.cantidad === '' || data.cantidad === 0) {
            Swal.fire({
                title: 'Venta empleado',
                text: 'Debe de ingresar cantidad',
                type: 'error',
            })
        } else {
            const producto = data.producto.value.split('#')
               
            const formData = {
                idProducto: producto[0],
                cantidad: data.cantidad,
                detalle: id_emp[8],
                total: parseFloat(parseFloat(data.cantidad)*parseFloat(producto[3])).toFixed(2)
            }
            dispatch(setLoader(true));
            api.post('/rrhh_venta_empleado_detalle/', formData).then((response) => {
                NotificationManager.success(
                    'Producto ingresado correctamente',
                    'Exito',
                    3000
                );
                dispatch(leerDetalleProductos(response.id));
                dispatch(initializeForm('FormVentaEmpleado', {
                    ...data,
                    producto: null
                }));
            }).catch((error) => {
                NotificationManager.error(
                    error.msj,
                    'Error',
                    2000
                );
            }).finally(() => {
                dispatch(setLoader(false));
            });
        }
    }
}

export const listarColaboradorReporte = (search) => () => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id, search };
    
    return api.get('/colaborador/buscar_colaborador_nomina',params).then(data=>{
        const list_emp = [];
        if(data){
            data.forEach(item=>{
                list_emp.push({
                    value: item.id,
                    label:  item.codigo+' - ' + item.nombre
                })
            })
        }
        return list_emp;
    }).catch((error)=>{
        return [];
    })
}

export const reporteVenta = () => (dispatch,getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const data = getStore().form.FormListaVentaEmpleado.values;
    
    let reporte = 'reporteVenta';
    let periodo = data.periodo
    let emp = data.colaborador ? data.colaborador.value : '';
    let resumen = data.resumen ? data.resumen : '';
    let tipo = data.tipo
    const params = { id, reporte, periodo, emp, tipo, resumen }
    dispatch(setLoaderRep(true));
    api.getPdf('/rrhh_reportes', params).then((response) => {
        if (response.headers['content-type'] == 'application/pdf') {
            var blob = new Blob([response.text], { type: 'application/pdf;charset=utf-8' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'reporte_pedidos.pdf';
            window.open(link, '_blank');
            return false;
        }
    }).catch((error) => {
        if (error.status === 404) {
            NotificationManager.error(
                "No se encontraron datos",
                "Error",
                2000
            );
        }
        if (error.status === 500) {
            NotificationManager.error(
                'Ocurrió un error al generar reporte',
                'Error',
                0
            );
        }
  
    }).finally(() => {
        dispatch(setLoaderRep(false));
    });
}

export const excelVenta = () => (dispatch,getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    const data = getStore().form.FormListaVentaEmpleado.values;
    
    let reporte = 'excelVenta';
    let periodo = data.periodo
    let emp = data.colaborador ? data.colaborador.value : '';
    let tipo = data.tipo
    const params = { id, reporte, periodo, emp, tipo }
    dispatch(setLoaderRep(true));
    api.getExcel('/rrhh_reportes', params).then((response) => {
        const blob = response;
        const fileName = 'venta_empleado.xlsx';

        // Descargar el archivo utilizando la función saveAs de file-saver
        const file = new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(file, fileName);
        
    }).catch((error) => {
        if (error.status === 404){
            NotificationManager.info(
                error.body.msj,
                'Informacion',
                5000
            );
        }
        if (error.status === 500){
            NotificationManager.error(
                'Ocurrió un error al generar reporte',
                'Error',
                0
            );
        }
    }).finally(() => {
        dispatch(setLoaderRep(false));
    });
}

export const actions = {
    listarColaborador,
    getModulo,
    registroVenta,
    datosColaborador,
    listar,
    leer,
    limpiarDatos,
    modificarVenta,
    listarPeriodos,
    leerPeriodoD,
    agregarLinea,
    listarProductos,
    eliminarLinea,
    eliminarLineaProducto,
    agregarLineaProducto,
    reporteVenta,
    listarColaboradorReporte,
    excelVenta
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LOADER_REP]: (state, { loaderRep }) => {
        return {
            ...state,
            loaderRep,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
    [COLABORADOR]: (state, { emp }) => {
        return {
            ...state,
            emp,
        };
    },
    [PUESTO]: (state, { cargo }) => {
        return {
            ...state,
            cargo,
        };
    },
    [LISTADO]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [TIPO]: (state, { tipo }) => {
        return {
            ...state,
            tipo,
        };
    },
    [LISTADO_PERIODOS]: (state, { periodos }) => {
        return {
            ...state,
            periodos,
        };
    },
    [PERIODO_D]: (state, { periodoD }) => {
        return {
            ...state,
            periodoD,
        };
    },
    [DETALLE]: (state, { detallePro }) => {
        return {
            ...state,
            detallePro,
        };
    },
    [DETALLE_PRODUCTOS]: (state, { detalleProducto }) => {
        return {
            ...state,
            detalleProducto,
        };
    },
};

export const initialState = {
    loader: false,
    loaderRep: false,
    modulo: [],
    data: [],
    emp: [],
    tipo: '',
    periodos: [],
    detallePro: [],
    detalleProducto: []
};

export default handleActions(reducers, initialState)
 